<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Performa Details</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <!-- <b-button
                :disabled="
                  ffInvoiceModal.sentForRevisedApproval == '1' ? true : false
                "
                @click="openPop"
                size="sm"
                variant="warning"
                v-if="
                  mainExecutionDetails.length > 0 &&
                  mainExecutionDetails[0].finalBillingCompleted == '1'
                "
                >Revised Performa Request</b-button
              ><br />
              <span
                class="error"
                v-if="ffInvoiceModal.revisedActionTakenFromMail == '2'"
                >Request Rejected</span
              >
              <span
                class="error"
                v-if="ffInvoiceModal.sentForRevisedApproval == '1'"
                >Sent For Approval</span
              >-->
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <banner-component
          :allModuleIdBanner="
            this.ffInvoiceModal.allModuleId
              ? this.ffInvoiceModal.allModuleId
              : ''
          "
          :jobSeriesBanner="
            this.ffInvoiceModal.jobNo ? this.ffInvoiceModal.jobNo : ''
          "
          :bannerClientName="
            this.ffInvoiceModal.clientName ? this.ffInvoiceModal.clientName : ''
          "
          iconId="fa fa-ship"
        />
        <b-card class="formCard">
          <b-card-text>
            <div class="box-header">
              <!-- <Splitmerge-Summary  :SM_Status="2" :title="'All Container Track - '" :SM_all_module_id="mainExecutionDetails[0].allModuleId" :SM_jb_series="mainExecutionDetails[0].mainSalesSeries" class="mt-2" /> -->
              <!-- <b-button
                v-if="
                  mainExecutionDetails.length > 0 &&
                  mainExecutionDetails[0].finalBillingCompleted == '0' 
                  
                "
                size="sm"
                variant="outline-dark"
                @click="showQuotation"
                class="pull-right"
                >Show Quotation</b-button
              >-->
              <!-- {{ffTallyInvoiceData}} -->
              <b-button
                v-if="
                  mainExecutionDetails.length > 0 && PerformaList.length > 0
                "
                style="margin-right: 1rem"
                size="sm"
                variant="outline-dark"
                @click="showMoreItem"
                class="pull-right"
              >
                {{
                showMoreNewItem == false
                ? "Show Existing Performa List"
                : "Add New Performa "
                }}
              </b-button>

              <!-- <b-button
                style="font-size: 0.675rem"
                class="mt-2"
                v-if="
                  mainExecutionDetails.length > 0 &&
                  showMoreNewItem == true &&
                  PerformaList.length > 0
                "
                size="sm"
                @click="
                  validateBilling(
                    mainExecutionDetails[0].allModuleId,
                    mainExecutionDetails[0].jobType
                  )
                "
                variant="outline-info"
              >Close Performa</b-button> -->
              <!-- <span
                style="color: green"
                v-html="mainExecutionDetails[0].assignmentCloseReason"
                v-if="mainExecutionDetails[0].assignmentCloseReason"
                >{{ mainExecutionDetails[0].assignmentCloseReason }}</span
              >-->
            </div>
            <div class="box-body gutr" v-if="ffTallyInvoiceData.length<=0 && tptTableData.length > 0 && setShowQuotation == true">
              <div class="box-header">
                <b-button
                  v-if="tempffTableArry.length > 0"
                  :variant="
                    tptTableArryType == 'FF' ? 'success' : 'outline-success'
                  "
                  @click="setQuotationType('FF')"
                >FF</b-button>
                <b-button
                  v-if="ccTableArry.length > 0"
                  :variant="
                    tptTableArryType == 'CC' ? 'success' : 'outline-success'
                  "
                  @click="setQuotationType('CC')"
                >CC</b-button>
                <b-button
                  v-if="tptTableData.length > 0"
                  :variant="
                    tptTableArryType == 'TPT' ? 'success' : 'outline-success'
                  "
                  @click="setQuotationType('TPT')"
                >TPT</b-button>
              </div>
            </div>
            <div class="box-body gutr" v-if="ffTallyInvoiceData.length<=0 && ccTableArry.length > 0 && setShowQuotation == true">
              <table id="tpt" class="table table-bordered" v-if="tptTableArryType == 'TPT'">
                <thead>
                  <tr>
                    <th>SN.</th>
                    <th v-if="tptModal.shipmentType == '1'">Container Type</th>
                    <th>Particulars</th>

                    <th>Buy In Rate</th>
                    <th>Selling Rate</th>
                    <th>Unit</th>
                    <th>Validity Date</th>
                    <th>Remarks</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item1, index) in tptTableData" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td v-if="tptModal.shipmentType == '1'">{{ item1.containerType }}</td>
                    <td>{{ item1.otherCharge }}</td>
                    <td>{{ item1.byInPrice }} {{ item1.currency }}</td>
                    <td>{{ item1.qRate }} {{ item1.currency }}</td>
                    <td>{{ item1.unitName ? item1.unitName : "NA" }}</td>
                    <td>{{ item1.validityDate }}</td>

                    <td>{{ item1.remark }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="box-body gutr" v-if="ffTallyInvoiceData.length<=0 && ccTableArry.length > 0 && setShowQuotation == true">
              <table id="cc" class="table table-bordered" v-if="tptTableArryType == 'CC'">
                <thead>
                  <tr>
                    <th>SN.</th>

                    <th v-if="enquiryData.shipmentType == '1'">Container Type</th>
                    <th>Particulars</th>
                    <th>Buy In Rate</th>
                    <th>Selling Rate</th>
                    <th>Validity Date</th>
                    <th>Unit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item1, index) in ccTableArry" :key="index">
                    <td>{{ index + 1 }}</td>

                    <td v-if="enquiryData.shipmentType == '1'">{{ item1.containerType }}</td>
                    <td>{{ item1.ccType }}</td>
                    <td>{{ item1.ccBuyingRate }} {{ item1.currency }}</td>
                    <td>{{ item1.ccSellingRate }} {{ item1.currency }}</td>
                    <td>{{ item1.validityDate }}</td>

                    <td>{{ item1.unitName ? item1.unitName : "NA" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="box-body gutr"
              v-if="ffTallyInvoiceData.length<=0 && tempffTableArry.length > 0 && setShowQuotation == true"
            >
              <table id="ff" class="table table-bordered" v-if="tptTableArryType == 'FF'">
                <thead>
                  <tr>
                    <th>SN.</th>
                    <th
                      v-if="
                        enquiryData.shipmentType == 1 &&
                        enquiryData.fclOrlcl == 'lcl'
                      "
                    >Co-Loader</th>
                    <th v-else-if="enquiryData.shipmentType == 1">Shipping Line</th>
                    <th v-else>Airline Name</th>
                    <th v-if="shipmentType == '1'">Container Type</th>
                    <th>Particulars</th>

                    <th>Buying Rate</th>
                    <th>Selling Rate</th>
                    <th>Quotation Validity Till</th>
                    <th>Validity Date</th>
                    <th>Unit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item1, index) in tempffTableArry" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td
                      v-if="
                        enquiryData.shipmentType == '1' &&
                        enquiryData.fclOrlcl == 'lcl'
                      "
                    >{{ item1.coLoaderName }}</td>
                    <td v-else-if="enquiryData.shipmentType == '1'">{{ item1.shippingLine }}</td>
                    <td v-else>{{ item1.airlineName }}</td>
                    <td v-if="enquiryData.shipmentType == '1'">{{ item1.containerType }}</td>
                    <td>{{ item1.ffType }}</td>

                    <td>{{ item1.buyingRate }} {{ item1.currency }}</td>
                    <td>{{ item1.ffSellingRate }} {{ item1.currency }}</td>
                    <td>
                      {{
                      item1.quotationTill == 1
                      ? "Validity Till Handover"
                      : "Validity Till Sailing"
                      }}
                    </td>
                    <td>{{ item1.ffvalidityDate }}</td>
                    <td>{{ item1.unitName ? item1.unitName : "NA" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="box" v-if="ffTallyInvoiceData.length<=0 && PerformaList.length > 0">
              <div class="box-body" v-if="showMoreNewItem == true">
                <table id="ffContainer" class="table table-bordered">
                  <tbody>
                    <tr>
                      <th>SN.</th>
                      <th>Performa Series</th>
                      <th>Client Name</th>
                      <th>Job Type</th>
                      <th>Performa Status</th>
                      <th>Date & Details</th>
                      <th>PDF</th>
                    </tr>
                    <tr v-for="(item1, index) in PerformaList" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td
                        class="showMoreData"
                        @click="getBillData(item1)"
                      >{{ item1.profarmaSeries }}</td>
                      <td>
                        {{ item1.clientName }}
                        <br />
                        <b-badge v-if="item1.invoiceForClient == '2'">Overseas Agent</b-badge>
                      </td>
                      <td>{{ item1.jobType }}</td>
                      <td>
                        {{
                        item1.addedToProformaSucessStatus == "1"
                        ? "Active"
                        : "In-Active "
                        }}
                      </td>

                      <td>
                        On {{ item1.loginTime }}
                        <br />
                        By {{ item1.employeeName }}
                        <br />
                        At {{ item1.profarmaLocationName }}
                      </td>
                      <!-- :href="`${docURL}/TALLY_PDF/` + item1.dataPdf" -->
                      <td>
                        <!-- {{item1}} -->
                        <a
                          v-if="item1.proformaPdf"
                          @click="PrintNote(item1.jobNo,item1.proformaPdf)"
                          target="_blank"
                          download
                        >View PDF</a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-if="ffTallyInvoiceData.length>0 || showMoreNewItem == false || PerformaList.length == 0">
              <md-layout md-gutter class="gutr" v-if="ffInvoiceModal.profarma_id == ''">
                <md-layout md-flex="90" md-flex-small="100">
                  <md-layout md-flex-small="100">
                    <md-layout
                      v-for="(segmentNameArray, index) in showSegmentArray"
                      :key="index"
                      :md-flex="segmentNameArray.flex"
                      md-flex-small="100"
                    >
                      <md-checkbox
                        v-model="ffInvoiceModal.jobType[index]"
                        class="md-primary"
                        :md-value="segmentNameArray.value"
                        :name="'jobType' + (index + 1)"
                        :id="'jobType' + (index + 1)"
                        @change="jobTypeSelect(segmentNameArray.value, index)"
                      >
                        <b>{{ segmentNameArray.show }}</b>
                      </md-checkbox>
                    </md-layout>
                  </md-layout>
                </md-layout>
              </md-layout>
                <!-- {{PreviousPerformaList}}
                {{newJobType}} -->
              <div class="box" v-if="PreviousPerformaList.length > 0 && newJobType.length > 0">
                <div class="box-body row">
                  <div
                    class="col-md-2"
                    v-for="(pre_item, pre_index) in PreviousPerformaList"
                    :key="pre_index"
                  >
                    <b-button
                      style="font-size: 0.675rem"
                      class="mt-2"
                      v-if="pre_item.profarmaSeries"
                      size="sm"
                      @click="getPreviousTallyData(pre_item)"
                      variant="info"
                    >
                      <b>{{ pre_item.profarmaSeries }}</b>
                    </b-button>
                  </div>
                </div>
              </div>

              <div>
                <md-layout md-gutter class="gutr">
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Job No.</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        disabled
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.jobNo"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Employee Performa Branch</label>

                      <model-list-select
                        :isDisabled="true"
                        @input="getBranch(ffInvoiceModal.profarmaLocationId,ffInvoiceModal.fk_branch_id)"
                        :list="
                          $store.getters['common/getAllBillingLocationList']
                        "
                        v-model="ffInvoiceModal.profarmaLocationId"
                        option-value="billingLocationId"
                        option-text="billingLocation"
                        placeholder="Select Performa Location"
                      ></model-list-select>
                    </md-layout>
                  </md-layout>
                  <!-- {{$store.getters['common/getAllBranchList']}}
                  {{$store.getters['common/getAllBranchOfficeList']}}-->
                  <!-- Branch and Office Start -->
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Branch</label>
                      <!-- {{ffInvoiceModal}} -->
                      <!-- {{$store.getters['common/getAllBranchList']}} -->
                      <model-list-select
                        :isDisabled="true"
                        @input="getOfficeBranch(ffInvoiceModal.profarmaLocationId,ffInvoiceModal.fk_branch_id)"
                        :list="
                          $store.getters['common/getAllBranchList']
                        "
                        v-model="ffInvoiceModal.fk_branch_id"
                        option-value="pickupId"
                        option-text="pickupLocation"
                        placeholder="Select Branch"
                      ></model-list-select>
                    </md-layout>
                  </md-layout>

                  <!-- {{this.BranchOfficeList}} -->
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Office</label>
 <!-- :isDisabled="
                          $sessionsStorage.get('designation') != 'Admin' &&
                          $sessionsStorage.get('nameUser') != 'Bhavneesh'
                            ? true
                            : false
                        " -->
                      <model-list-select
                       
                        :list="BranchOfficeList"
                        v-model="ffInvoiceModal.fk_office_id"
                        option-value="office_id"
                        option-text="office_name"
                        placeholder="Select Office"
                      ></model-list-select>
                    </md-layout>
                  </md-layout>
                  <!-- Branch and Office End -->

                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="5">
                    <div class="mr-4">
                      <label style="width: 80px">Other Clients</label>
                      <b-form-checkbox
                        style="padding-top: 0px"
                        v-model="otherClientChecked"
                        name="check-button"
                        switch
                      ></b-form-checkbox>
                    </div>
                  </md-layout>

                  <md-layout
                    md-flex="15"
                    v-if="
                      mainExecutionDetails.length > 0 &&
                      mainExecutionDetails[0].clientType == '3'
                    "
                  >
                    <label for="containerTypeId">Invoice For</label>
                    <model-list-select
                      @input="changeClient"
                      :list="clientTypeList"
                      v-model="ffInvoiceModal.invoiceForClient"
                      option-value="inv"
                      option-text="int"
                      placeholder="Select "
                    ></model-list-select>
                  </md-layout>
                  <md-layout
                    md-flex="5"
                    v-if="
                      mainExecutionDetails.length > 0 &&
                      mainExecutionDetails[0].clientType == '3'
                    "
                  ></md-layout>
                  <md-layout md-flex="15">
                    <label for="containerTypeId">Client Name</label>
                    <model-list-select
                      :isDisabled="otherClientChecked == false ? true : false"
                      @input="changeOtherClient"
                      :list="$store.getters['common/getAllClientList']"
                      v-model="ffInvoiceModal.clientId"
                      option-value="clientId"
                      option-text="clientName"
                      placeholder="Select "
                    ></model-list-select>
                  </md-layout>

                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Client Contact</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.contact"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Client GSTN</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.clientgst"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>State</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.stateName"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="45">
                    <md-layout md-flex="100">
                      <label>Client Address</label>
                      <b-form-textarea
                        :formatter="capitalizeAll"
                        id="clientRegistrationNo"
                        name="clientRegistrationNo"
                        v-model="ffInvoiceModal.adress"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>

                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Pickup Location</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.pickup"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Handover Location</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.Handover"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Factory Location</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.factoryLoc"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>

                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Place Of Receipt</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.POR"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Load Port</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.LP"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Port Of Discharge</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.POD"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>

                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Final Place of Delivery</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.FPOD"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>

                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Shipping Line Name</label>
                      <b-form-textarea
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.shippingLine"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Vessel / Voyage</label>
                      <b-form-textarea
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.vessel"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>
                </md-layout>
                <h5 class="mt-4">
                  <b-badge variant="info">
                    Container Details :
                    {{ allContainersDataArray.length }} Container
                  </b-badge>
                  <b-badge variant="info">
                    Selected Containers :
                    {{ singleSelectContainer.length }}
                  </b-badge>
                </h5>
                <md-layout
                  md-gutter
                  class="gutr"
                  v-if="
                    $store.getters['common/getAllSplitedOrMergedContainersList']
                      .length > 0
                  "
                >
                  <md-layout md-flex="40">
                    <label>Container Moved to other assignment</label>
                    <model-list-select
                      @input="pushSplitedContainers"
                      :list="
                        $store.getters[
                          'common/getAllSplitedOrMergedContainersList'
                        ]
                      "
                      v-model="splitOrMergeConNo"
                      option-value="uniqueContainerId"
                      option-text="containerNo"
                      placeholder
                    ></model-list-select>
                  </md-layout>
                </md-layout>
                <table class="table table-sm mt-4 shadow p-3 mb-5 bg-white rounded">
                  <tbody>
                    <tr>
                      <th bgcolor="whiteSmoke" style="width: 20px">
                        <input
                          type="checkbox"
                          @click="SelectAll(allContainersDataArray)"
                          v-model="isCheckAll"
                        />
                        <label>
                          Select All Count({{
                          this.singleSelectContainer.length
                          }})
                        </label>
                      </th>
                      <th bgcolor="whiteSmoke">Container Type & No.</th>
                      <th>Shipping Bills</th>
                      <th>Shipper Invoices</th>
                      <!-- <th>Invoice Added JobNo</th> -->
                    </tr>
                    <tr v-for="(item, index) in allContainersDataArray" :key="index">
                      <td
                        style="
                          text-align: center;
                          vertical-align: middle;
                          width: 20px;
                        "
                        bgcolor="whiteSmoke"
                      >
                        <b-form-checkbox
                          :disabled="
                            item.onlyTPT == '1' &&
                            (newJobType.includes('FF') ||
                              newJobType.includes('CC') ||
                              newJobType.length <= 0)
                              ? true
                              : false
                          "
                          size="lg"
                          v-model="singleSelectContainer"
                          :value="item.uniqueContainerId"
                          @change="updateSelectAll($event, item)"
                        ></b-form-checkbox>
                      </td>
                      <td
                        style="
                          text-align: left;
                          vertical-align: middle;
                          width: 200px;
                        "
                        :bgcolor="item.onlyTPT == '1' ? 'red' : 'whiteSmoke'"
                      >
                        <span>{{ item.containerType }}</span>
                        <b v-if="item.containerNo">
                          <br />
                          {{ item.containerNo }}
                        </b>
                        <br />
                        <b-button
                          v-if="item.onlyTPT == '1'"
                          @click="removeContainerType(index)"
                          size="sm"
                          class="pull-right"
                          variant="warning"
                        >
                          <i class="fa fa-minus-circle"></i>
                        </b-button>

                        <!-- <span style="color: blue" v-if="item.invoiceNoCreated"
                          ><br /><b
                            >Invoice Created: {{ item.invoiceNoCreated }}</b
                          ></span
                        >-->
                      </td>

                      <td>
                        SB No. : {{ item.shippingBillNo }}
                        <br />
                        SB Date :
                        {{
                        item.shippingBillDate
                        ? item.shippingBillDate.split(" ")[0]
                        : ""
                        }}
                      </td>
                      <td>
                        Shipper Inv No. : {{ item.shipperInvoiceNo }}
                        <br />
                        Date :
                        {{
                        item.shipperInvoiceDate
                        ? item.shipperInvoiceDate.split(" ")[0]
                        : ""
                        }}
                      </td>
                      <!-- <td>
                        {{ item.assignNoInwhichInvCreated }}
                      </td>-->
                    </tr>
                  </tbody>
                </table>
                <md-layout md-gutter class="gutr">
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Container No.</label>
                      <b-form-textarea
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.containerDetailsNew"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Container Type</label>
                      <b-form-textarea
                        :formatter="capitalizeAll"
                        id="multipleContainerType"
                        name="multipleContainerType"
                        v-model="ffInvoiceModal.multipleContainerType"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>

                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Shipping Bill No/ Date</label>
                      <b-form-textarea
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.BOE"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Shipper Invoice No.</label>
                      <b-form-textarea
                        :formatter="capitalizeAll"
                        id="clientRegistrationNo"
                        name="clientRegistrationNo"
                        v-model="ffInvoiceModal.shipperInvNo"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Shipper Invoice Date</label>
                      <b-form-textarea
                        :formatter="capitalizeAll"
                        id="clientRegistrationNo"
                        name="clientRegistrationNo"
                        v-model="ffInvoiceModal.shipperInvDate"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>

                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>BL No</label>
                      <b-form-textarea
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.blNo"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>

                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Weight (KGS)</label>
                      <b-form-textarea
                        :formatter="capitalizeAll"
                        id="clientName"
                        name="clientName"
                        v-model="ffInvoiceModal.weight"
                      ></b-form-textarea>
                    </md-layout>
                  </md-layout>
                </md-layout>

                <md-layout class="gutr">
                  <div class="box-body gutr" v-if="TPTGRNDATA.length > 0">
                    <h5>
                      <b-badge variant="info">TPT Annexure Details</b-badge>
                    </h5>
                    <table id="quotationDetail" class="table table-bordered table-sm gutr">
                      <tbody>
                        <tr>
                          <th>GRN Number</th>
                          <th>Container Number & Type</th>
                          <th>Fuel Slip No.</th>
                          <th>Vehicle No</th>
                          <th>S-Line Seal No.</th>
                          <th>Custom Seal No.</th>
                          <th>Date</th>
                        </tr>
                        <tr v-for="(item, index) in TPTGRNDATA" :key="index">
                          <td>
                            <a @click="getGRNpdf(item.pdfGRN)" class="error">
                              <span class="error">
                                <u>{{ item.GRNSeries }}</u>
                              </span>
                            </a>
                          </td>

                          <td>
                            {{ item.containerNo }}
                            <br />
                            {{ item.multipleContainerType }}
                          </td>
                          <td>{{ item.FuelSlipNo }}</td>
                          <td>{{ item.vehicleNo }}</td>
                          <td>{{ item.slineSealNo }}</td>
                          <td>{{ item.customSealNo }}</td>
                          <td>
                            <span>Loading Date :{{ item.Date | moment }}</span>
                            <br />
                            <span>
                              Reporting Date :{{
                              item.factoryInDate | moment
                              }}
                            </span>
                            <br />
                            <span>
                              Released Date :{{
                              item.factoryOutDate | moment
                              }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </md-layout>

                <md-layout
                  md-gutter
                  v-if="
                    mainExecutionDetails.length > 0 &&
                    tempffTableArry.length > 0
                  "
                >
                  <md-layout md-flex="20">
                    <label for="clientId">CURRENCY</label>

                    <model-list-select
                      :list="$store.getters['common/getAllCurrencyList']"
                      id="clientNamenew"
                      v-model="mainExecutionDetails[0].currencyType"
                      option-value="currencyCode"
                      option-text="currencyCode"
                      placeholder="Currency Type"
                      :isDisabled="true"
                    ></model-list-select>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>

                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>AGREED BUYING OCEAN RATE *</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        disabled
                        name="agreedByingOceanRate"
                        id="agreedByingOceanRate"
                        v-model="mainExecutionDetails[0].agreedByingOceanRate"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>

                  <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>AGREED SELLING OCEAN RATE *</label>
                      <b-form-input
                        :formatter="capitalizeAll"
                        disabled
                        name="agreedSellingOceanRate"
                        id="agreedSellingOceanRate"
                        v-model="mainExecutionDetails[0].agreedSellingOceanRate"
                      ></b-form-input>
                    </md-layout>
                  </md-layout>
                </md-layout>
              </div>
            </div>
          </b-card-text>
        </b-card>
        <div
          class="mt-2"
          v-if="
            showMoreNewItem == false ||
            ffInvoiceModal.profarma_id != '' ||
            PerformaList.length == 0 || 
            ffTallyInvoiceData.length>=0
          "
        >
          <b-form-checkbox
            v-if="
              ffInvoiceModal.profarma_id != '' &&
              mainExecutionDetails.length > 0
            "
            size="lg"
            @change="copyCharges"
            value="notSelected"
            v-model="selectedTallyInv"
          >Select to Update Charges Details</b-form-checkbox>

          <div>
            <h5>
              <b-badge variant="info">CHARGES</b-badge>
              <b-button
                class="ml-1"
                v-if="ffInvoiceModal.profarma_id == ''"
                size="sm"
                variant="outline-info"
                @click="addQuotationFields"
              >
                <md-icon md-va>add</md-icon>
              </b-button>
            </h5>
            <table
              id="quotationDetail"
              class="table table-responsive-lg mt-3 table-light table-bordered shadow p-3 mb-5 bg-white rounded"
            >
              <tbody>
                <tr>
                  <th style="width: 45px">
                    <b-form-checkbox
                      v-model="slectedAllStatus"
                      class="ml-2"
                      value="1"
                      unchecked-value="0"
                      @input="SelectedAll"
                    ></b-form-checkbox>
                  </th>

                  <th style="width: 170px">
                    <span>Particulars *</span>
                  </th>

                  <th v-if="shipmentType == '1'">
                    <span>Container Type</span>
                  </th>
                  <th style="width: 82px">
                    <span>Quantity *</span>
                  </th>
                  <th>
                    <span>Currency *</span>
                  </th>
                  <th style="width: 130px">
                    <span>Quotation Rate </span>
                  </th>
                  <th style="width: 130px">
                    <span>Selling Rate *</span>
                  </th>
                  <th style="width: 100px">
                    <span>Exch Rate *</span>
                  </th>

                  <th style="width: 130px">
                    <span>Final Amount *</span>
                  </th>

                  <th>
                    <span>Unit *</span>
                  </th>
                  <th>
                    <span>Remarks</span>
                  </th>
                </tr>
                <tr v-for="(item, index) in ffTallyInvoiceData" :key="index">
                  <td :bgColor="item.color && item.color == '1' ? 'green' : ''">
                    <b-form-checkbox
                      v-model="item.slectedStatus"
                      class="mt-3 ml-2"
                      value="1"
                      unchecked-value="0"
                    ></b-form-checkbox>
                  </td>
                  <td>
                    <model-list-select
                      class="parti"
                      :list="$store.getters['common/getAllLedgerList']"
                      @input="getDuplicateLedger(item, index)"
                      v-model="item.ffType"
                      option-value="ledger"
                      option-text="ledger"
                    ></model-list-select>
                  </td>
                  <td v-if="shipmentType == '1'">
                    <model-list-select
                      v-if="shipmentType == '1'"
                      :list="$store.getters['common/getAllContainerTypeList']"
                      v-model="item.containerType"
                      option-value="containerType"
                      option-text="containerType"
                    ></model-list-select>
                  </td>

                  <td>
                    <b-form-input
                      :formatter="capitalizeAll"
                      @input="getFinalAmount(index)"
                      type="number"
                      v-model="item.quantity"
                    ></b-form-input>
                  </td>
                  <td>
                    <model-list-select
                      :list="$store.getters['common/getAllCurrencyList']"
                      v-model="item.currency"
                      option-value="currencyCode"
                      option-text="currencyCode"
                    ></model-list-select>
                  </td>
                  <td>
                    <b-form-input
                      :formatter="capitalizeAll"
                      :disabled="item.ffSellingRate ? true : false"
                      @input="getFinalAmount(index)"
                      type="number"
                      v-model="item.ffSellingRate"
                    ></b-form-input>
                  </td>
                  <td>
                    <b-form-input
                      :formatter="capitalizeAll"
                      @input="getFinalAmount(index)"
                      type="number"
                      v-model="item.sellingRateFinal"
                    ></b-form-input>
                  </td>

                  <td>
                    <b-form-input
                      :formatter="capitalizeAll"
                      @input="getFinalAmount(index)"
                      type="number"
                      v-model="item.exchRate"
                    ></b-form-input>
                  </td>
                  <td>
                    <b-form-input
                      :formatter="capitalizeAll"
                      type="number"
                      v-model="item.invAmount"
                      v-on:keyup="MainParticular"
                    ></b-form-input>
                  </td>

                  <td>
                    <model-list-select
                      :list="$store.getters['common/getAllUnitList']"
                      v-model="item.unit"
                      option-value="unitId"
                      option-text="unitName"
                    ></model-list-select>
                  </td>

                  <td>
                    <b-form-textarea :formatter="capitalizeAll" v-model="item.remark"></b-form-textarea>
                  </td>
                </tr>
                <tr v-if="ffTallyInvoiceData.length > 0">
                  <td colspan="8"></td>
                  <td colspan="2">
                    <b>Total :</b>
                    <span>
                      <b>{{ totFinalPartAmount }}</b>
                    </span>
                  </td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>

          <md-layout md-gutter class="mrgtop-2per gutr mt-5">
            <md-layout md-flex="35"></md-layout>
            <md-layout md-flex="30">
              <b-button
                block
                v-if="ffInvoiceModal.profarma_id == ''"
                variant="primary"
                @click="cretaeProforma"
                id="addButtonLoader"
              >
                {{
                ffInvoiceModal.profarma_id != ""
                ? "Update"
                : "Proceed To Performa Invoice"
                }}
              </b-button>
              <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
            </md-layout>
            <md-layout md-flex="20"></md-layout>
          </md-layout>
        </div>
      </b-card-text>
    </b-card>
    <b-modal
      id="modal-close-conf"
      ref="modal-close-conf"
      title="Submit Your Reason"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <h3>Confirmation</h3>
      <h4 class="error" v-if="incompleteJobBill">
        <small>Invoice Not added for</small>
        {{ incompleteJobBill }}
        <small>Please Kindly Check..!</small>
      </h4>

      <form ref="form">
        <b-form-group
          label="Reason for closing Assignment Performa"
          label-for="name-input"
          invalid-feedback="Name is required"
        >
          <b-form-textarea
            :formatter="capitalizeAll"
            rows="5"
            id="name-input"
            v-model="closingReason"
            required
          ></b-form-textarea>
        </b-form-group>
      </form>

      <b-button
        :disabled="closingReason ? false : true"
        variant="success"
        @click="closeBillOk"
      >Confirm & Close Performa</b-button>
      <b-button @click="closeModalConfirm" variant="danger" class="pull-right">Cancel</b-button>
    </b-modal>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPopMaxPer"></md-dialog-alert>
    <md-dialog-confirm
      :md-title="confirm.title"
      :md-content-html="confirm.contentHtml"
      :md-ok-text="confirm.ok"
      :md-cancel-text="confirm.cancel"
      @close="sendMail"
      ref="popMail"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="closeBillOk"
      ref="addPopClose"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="submitInvoice"
      ref="addPopTally"
    ></md-dialog-confirm>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop6"></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import SplitmergeSummary from "../common/splitmergeSummary.vue";
import BannerComponent from "../allModuleForm/bannerComponent.vue";
import CommonService from "../../services/CommonService.js";

export default {
  beforeMount() {
    // if (globalPermissionStatus("Accounts")) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/freightForward/freightInvoiceForTally"
      );
      // this.$store.dispatch(
      //   "common/setAllBranchList",
      //   JSON.stringify({
      //     filter: "BranchList",
      //     active: "all"
      //   })
      // );
      this.$store.dispatch(
        "common/setAllSplitedOrMergedContainersList",
        JSON.stringify({
          itemCode: "SplitedOrMergedContainersList",
          allModuleId: this.$route.params.allModuleId
        })
      );
      this.$store.dispatch(
        "common/setAllCurrencyList",
        JSON.stringify({ Currency: "Currency_DropDown" })
      );
      this.$store.dispatch(
        "common/setAllLedgerList",
        JSON.stringify({
          itemCode: "LedgerList",
          JobType:'',
          ShipmentType:'',
          ModuleType:'',
          isLedgerActive:'1',
        })
      );
      this.$store.dispatch(
        "common/setAllBillingLocationList",
        JSON.stringify({
          itemCode: "BillingLocationList"
        })
      );
      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({
          itemCode: "ClientList"
        })
      );
      this.$store.dispatch(
        "common/setAllUnitList",
        JSON.stringify({
          itemCode: "UnitList"
        })
      );
      this.$store.dispatch(
        "common/setAllContainerTypeList",
        JSON.stringify({
          itemCode: "ContainerTypeList"
        })
      );
      this.getData();
    // } else {
    //   this.$router.push({
    //     path: "/dashboard"
    //   });
    // }
  },
  data() {
    return {
      BranchOfficeList: [],
      isCheckAll: false,
      totFinalPartAmount: "0",
      closingReason: "",
      incompleteJobBill: "",
      tempffTableArry: [],
      tptTableData: [],
      ccTableArry: [],
      enquiryData: {
        shipmentType: "",
        fclOrlcl: ""
      },
      setShowQuotation: false,
      tptTableArryType: "FF",
      tptModal: {},
      classId: "",
      confirm: {
        title: "Confirmation..!",
        contentHtml: "Data",
        ok: "Send",
        cancel: "Cancel"
      },
      invoiceStatusList: [
        {
          inv: "0",
          int: "In-Complete"
        },
        {
          inv: "1",
          int: "Completed"
        }
      ],
      splitOrMergeConNo: "",
      showMoreNewItem: true,
      selectedTallyInv: "",
      selectedAllModuleId: "",
      showBill: false,
      ccInvoiceTallyData: [],
      miscInvoiceTallyData: [],
      tallyTableData: [],
      validateTally: false,
      docURL: URL_BASE_DOC,
      currencyList: [
        {
          currencyV: "INR",
          currencyT: "INR"
        },
        {
          currencyV: "USD",
          currencyT: "USD"
        },
        {
          currencyV: "EURO",
          currencyT: "EURO"
        },
        {
          currencyV: "GBP",
          currencyT: "GBP"
        },
        {
          currencyV: "ZAR",
          currencyT: "ZAR"
        },
        {
          currencyV: "CAD",
          currencyT: "CAD"
        },
        {
          currencyV: "JOD",
          currencyT: "JOD"
        },
        {
          currencyV: "AED",
          currencyT: "AED"
        }
      ],

      isLoading: false,
      containerNoName: [],
      TPTInvoiceTallyData: [],
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      CCCheckDone: 0,
      ffCheckDone: 0,
      TPTCheckDone: 0,
      miscCheckDone: 0,
      yardCheckDone: 0,
      ibCheckDone: 0,
      TPTGRNDATA: [],
      TPTGRNID: [],
      TPTMERGECONTAINERCHARGEID: [],

      TOLLPRICE: "",
      shipmentType: "",
      PerformaList: [],
      PreviousPerformaList: [],
      containerMasterData: [],
      mainExecutionDetails: [],
      jobTypeSelectVal: false,
      showSegmentArray: [],
      currencyTypeList: [
        {
          type: "USD",
          val: "1"
        },
        {
          type: "INR",
          val: "2"
        }
      ],
      clientTypeList: [
        {
          inv: "1",
          int: "Client"
        },
        {
          inv: "2",
          int: "Oversea Agent"
        }
      ],
      cTypeList: [
        {
          inv: "1",
          int: "Client"
        }
      ],
      overTypeList: [
        {
          inv: "2",
          int: "Oversea Agent"
        }
      ],
      showOverSea: false,
      selectedValue: "",
      clist: false,
      slectedAllStatus: "0",
      otherClientChecked: false,
      ffInvoiceModal: {
        splitFromId: "",
        fromAgentColoderTable: "N",
        manualprofarma: "0",
        tallyprofarmaSeries: 1,
        billingStatus: "0",
        invoiceForClient: "",
        acutalclientForOverSea: "",
        otherChargeFF: "",
        BILLDONE: [],
        FFtallyId: [],
        profarmaLocationId: "",
        fk_branch_id: "",
        fk_office_id: "",
        profarmaLocationName: "",
        shipperInvNoforTally: "",
        shipperInvDateforTally: "",
        shipperInvNo: "",
        shipperInvDate: "",
        stateName: "",
        clientgst: "",
        TOLCHRG: "",
        TPTCHARGES: "",
        secondFF: "",
        multiTPT: "",
        grnNo: "",
        pickup: "",
        Handover: "",
        factoryLoc: "",

        jobType: [],
        jobTypeName: [],
        chnageApprovalStatus: "",
        profarma_id: "",
        invDate: "",
        jobNo: "",
        sentForRevisedApproval: "",
        revisedActionTakenFromMail: "",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        allModuleId: "",
        ccTypeExImp: "",
        PortAdditionalCharges: "",
        totalAmount: "",
        weight: "",
        vessel: "",
        blNo: "",
        masterBlNo: "",
        houseBlNo: "",
        BOE: "",
        clientId: "",
        clientName: "",
        contact: "",
        adress: "",
        POR: "",
        LP: "",
        POD: "",
        FPOD: "",
        containerDetailsNew: "",
        containerDetailsCC: [],
        containerDetails: [],
        multipleContainerType: "",
        multiConNo: [],
        shippingLine: ""
      },
      newJobType: [],
      disableJobType: [],
      validateInvoice: true,
      ffTallyInvoiceData: [],
      ffInvSummaryData: [],
      ccContainers: [],
      ffContainers: [],
      revisedSavedBillingData: [],
      allContainersDataArray: [],
      singleSelectContainer: []
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    }
  },

  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    SplitmergeSummary,
    BannerComponent
  },
  watch: {
    singleSelectContainer(newVal, oldVal) {
      let dataArray = [];
      this.TPTGRNID = [];
      this.TPTMERGECONTAINERCHARGEID = [];
      let conArry = [];
      let conTypeAry = [];
      let SBNo_Arry = [];
      let SBNo_DateArry = [];
      let shiperInvArry = [];
      let shipperInvDateArry = [];

      for (let j = 0; j < this.singleSelectContainer.length; j++) {
        let arrySelect = this.allContainersDataArray.filter(p => {
          return p.uniqueContainerId == this.singleSelectContainer[j];
        });
        dataArray.push(...arrySelect);
      }

      for (let t = 0; t < dataArray.length; t++) {
        if (dataArray[t].moduleIdInwhichInvCreated) {
          if (
            dataArray[t].moduleIdInwhichInvCreated.split(",")[0] !==
            this.ffInvoiceModal.allModuleId
          ) {
            this.alert.content =
              "Container Already  Billed in other assignment ";
            this.$refs["addPop"].open();
          }
        }
        this.TPTGRNID.push(dataArray[t].tptGrnId);

        if (dataArray[t].fromSplitMergeAssignId != 0) {
          this.TPTMERGECONTAINERCHARGEID.push(dataArray[t].tptGrnAssignmentId);
        }
        conArry.push(dataArray[t].containerNo);
        conTypeAry.push(dataArray[t].containerType);
        if (dataArray[t].shippingBillNo) {
          SBNo_Arry.push(dataArray[t].shippingBillNo);
        }
        if (dataArray[t].shippingBillDate) {
          SBNo_DateArry.push(dataArray[t].shippingBillDate);
        }
        if (dataArray[t].shipperInvoiceNo) {
          shiperInvArry.push(dataArray[t].shipperInvoiceNo);
        }
        if (dataArray[t].shipperInvoiceDate) {
          shipperInvDateArry.push(dataArray[t].shipperInvoiceDate);
        }
      }

      if (conArry.length > 0) {
        this.ffInvoiceModal.containerDetailsNew = [
          ...new Set(conArry)
        ].toString();
        this.ffInvoiceModal.multipleContainerType = [
          ...new Set(conTypeAry)
        ].toString();
        this.ffInvoiceModal.multipleContainerType_New = [conTypeAry].toString();
      } else {
        this.ffInvoiceModal.containerDetailsNew = "";
        this.ffInvoiceModal.multipleContainerType = "";
      }

      if (SBNo_Arry.length > 0) {
        this.ffInvoiceModal.BOE =
          [...new Set(SBNo_Arry)].toString() +
          " / " +
          [...new Set(SBNo_DateArry)].toString();
      } else if (this.tallyTableData.length > 0 && this.tallyTableData[0].BOE) {
        this.ffInvoiceModal.BOE = this.tallyTableData[0].BOE;
        this.ffInvoiceModal.blNo = this.tallyTableData[0].blNo;
        this.ffInvoiceModal.vessel = this.tallyTableData[0].vessel;
        this.ffInvoiceModal.weight = this.tallyTableData[0].weight;
      } else if (
        this.ccInvoiceTallyData.length > 0 &&
        this.ccInvoiceTallyData[0].BOE
      ) {
        this.ffInvoiceModal.BOE = this.ccInvoiceTallyData[0].BOE;
        this.ffInvoiceModal.blNo = this.tallyTableData[0].blNo;
        this.ffInvoiceModal.vessel = this.tallyTableData[0].vessel;
        this.ffInvoiceModal.weight = this.tallyTableData[0].weight;
      } else {
        this.ffInvoiceModal.BOE = "";
      }
      if (shiperInvArry.length > 0) {
        this.ffInvoiceModal.shipperInvNo = [
          ...new Set(shiperInvArry)
        ].toString();

        this.ffInvoiceModal.shipperInvNoforTally = [
          ...new Set(shiperInvArry)
        ].toString();
      } else if (
        this.tallyTableData.length > 0 &&
        this.tallyTableData[0].shipperInvNo
      ) {
        this.ffInvoiceModal.shipperInvNoforTally = this.tallyTableData[0].shipperInvNo;

        this.ffInvoiceModal.shipperInvNo = this.tallyTableData[0].shipperInvNo;
      } else if (
        this.ccInvoiceTallyData.length > 0 &&
        this.ccInvoiceTallyData[0].shipperInvNo
      ) {
        this.ffInvoiceModal.shipperInvNoforTally = this.ccInvoiceTallyData[0].shipperInvNo;

        this.ffInvoiceModal.shipperInvNo = this.ccInvoiceTallyData[0].shipperInvNo;
      } else {
        this.ffInvoiceModal.shipperInvNo = "";
        this.ffInvoiceModal.shipperInvNoforTally = "";
      }
      if (shipperInvDateArry.length > 0) {
        this.ffInvoiceModal.shipperInvDate = [
          ...new Set(shipperInvDateArry)
        ].toString();
        this.ffInvoiceModal.shipperInvDateforTally = [
          ...new Set(shipperInvDateArry)
        ].toString();
      } else if (
        this.tallyTableData.length > 0 &&
        this.tallyTableData[0].shipperInvDate
      ) {
        this.ffInvoiceModal.shipperInvDateforTally = this.tallyTableData[0].shipperInvDate;

        this.ffInvoiceModal.shipperInvDate = this.tallyTableData[0].shipperInvDate;
      } else if (
        this.ccInvoiceTallyData.length > 0 &&
        this.ccInvoiceTallyData[0].shipperInvDate
      ) {
        this.ffInvoiceModal.blNo = this.tallyTableData[0].blNo;

        this.ffInvoiceModal.vessel = this.tallyTableData[0].vessel;

        this.ffInvoiceModal.weight = this.tallyTableData[0].weight;
        this.ffInvoiceModal.shipperInvDateforTally = this.ccInvoiceTallyData[0].shipperInvDate;

        this.ffInvoiceModal.shipperInvDate = this.ccInvoiceTallyData[0].shipperInvDate;
      } else {
        this.ffInvoiceModal.shipperInvDate = "";
        this.ffInvoiceModal.shipperInvDateforTally = "";
      }
      if (this.TPTGRNID.length > 0) {
        this.TPTGRNID = this.TPTGRNID.toString();
        this.TPTMERGECONTAINERCHARGEID = [
          ...new Set(this.TPTMERGECONTAINERCHARGEID)
        ].toString();
        this.linkContainer(
          "",
          "2",
          this.TPTGRNID,
          this.TPTMERGECONTAINERCHARGEID
        );
      }
    },
    deep: true
  },
  computed: {},
  methods: {
    setQuotationType(type) {
      this.tptTableArryType = type;
    },
    showQuotation() {
      if (this.tempffTableArry.length > 0) {
        this.tptTableArryType = "FF";
      } else if (this.ccTableArry.length > 0) {
        this.tptTableArryType = "CC";
      } else {
        this.tptTableArryType = "TPT";
      }
      this.setShowQuotation = !this.setShowQuotation;
    },
    getGRNpdf(item) {
      window.open(`${this.docURL}/` + item);
    },
    removeContainerType(index) {
      this.allContainersDataArray.splice(index, 1);
    },
    pushSplitedContainers() {
      let array1 = this.$store.getters[
        "common/getAllSplitedOrMergedContainersList"
      ].filter(x => {
        return x.uniqueContainerId == this.splitOrMergeConNo;
      });

      if (array1.length > 0) {
        let array2 = this.allContainersDataArray.filter(x => {
          return x.uniqueContainerId == this.splitOrMergeConNo;
        });
        if (array2.length <= 0) {
          array1[0]["onlyTPT"] = "1";
          this.allContainersDataArray.push(...array1);
        }
      }
    },
    linkContainer(item, id, GR, mergeConCharge) {
      this.TPTGRNDATA = [];
      this.TPTMergeConInvoiceTallyData = [];
      this.ffTallyInvoiceData = this.ffTallyInvoiceData.filter(
        el => el.color !== "1"
      );
      this.isLoading = true;
      let payload = {};
      if (id == "1") {
        payload = {
          fromSplitMergeAssignId: item.fromSplitMergeAssignId,
          splitedToOrMergedToAssignId: item.splitedToOrMergedToAssignId,
          uniqueContainerId: item.uniqueContainerId,
          containerNo: item.containerNo,
          tptGrnId: item.tptGrnId,
          fetchId: id
        };
      } else {
        payload = {
          tptGrnId: GR,
          mergeConCharge: mergeConCharge,
          fetchId: id,
          job: this.newJobType,
          getCCSplitChargesId: this.mainExecutionDetails[0].splitFromId
        };
      }
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/linkContainerForBilling_NewV3.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.TPTGRNDATA.length > 0) {
              this.TPTGRNDATA = data.TPTGRNDATA;
              this.TOLLPRICE = parseInt(data.TPTGRNDATA[0].tollPrice);
            } else {
              this.TOLLPRICE = 0;
            }
            if (data.TPTMergeConInvoiceTallyData.length > 0) {
              let TPTParti = [];
              let TPTCon = [];
              let TPTSelO = [];
              let TPTSF = [];
              let TPTINV = [];
              let TPTRE = [];
              let TPTQUN = [];
              let INVID = [];
              let UNT = [];

              if (data.TPTMergeConInvoiceTallyData.length > 0) {
                this.TPTMergeConInvoiceTallyData =
                  data.TPTMergeConInvoiceTallyData;

                for (
                  let p = 0;
                  p < this.TPTMergeConInvoiceTallyData.length;
                  p++
                ) {
                  TPTParti = this.TPTMergeConInvoiceTallyData[
                    p
                  ].particulars.split(",");
                  INVID = this.TPTMergeConInvoiceTallyData[p].invoiceId;
                  TPTCon = this.TPTMergeConInvoiceTallyData[
                    p
                  ].containerType.split(",");
                  TPTQUN = this.TPTMergeConInvoiceTallyData[p].quantity.split(
                    ","
                  );
                  UNT = this.TPTMergeConInvoiceTallyData[p].unit.split(",");
                  TPTSelO = this.TPTMergeConInvoiceTallyData[
                    p
                  ].quotationRate.split(",");
                  TPTSF = this.TPTMergeConInvoiceTallyData[
                    p
                  ].sellingRateFinal.split(",");
                  TPTINV = this.TPTMergeConInvoiceTallyData[
                    p
                  ].finalRateWithoutTax.split(",");
                  TPTRE = this.TPTMergeConInvoiceTallyData[p].remark.split(",");
                  if (TPTParti.length > 0) {
                    TPTParti.map((z, index) => {
                      let obj2 = {
                        ffType: z,
                        containerType: TPTCon[index],
                        quantity: TPTQUN[index],
                        ffSellingRate: TPTSelO[index],
                        exchRate: 1,
                        sellingRateFinal: TPTSF[index],
                        unit: UNT[index],
                        invAmount: TPTINV[index],
                        currency: "INR",

                        remark:
                          TPTINV[index] == "Charges As Per Receipt"
                            ? "Charges As Per Receipt " + " && " + TPTRE[index]
                            : TPTRE[index],
                        mainffId: INVID,
                        slectedStatus: "0",
                        color: "1"
                      };
                      this.ffTallyInvoiceData.push(obj2);
                    });
                  }
                }
              }
            }
            if (data.CCMergeConInvoiceTallyData.length > 0) {
              let CCParti = [];
              let CCCon = [];
              let CCSellingR = [];
              let CCSF = [];
              let CCInvAmt = [];
              let CCCurrency = [];
              let CCQuantity = [];
              let CCRemark = [];
              let UN = [];
              let EXRTCC = [];

              if (data.CCMergeConInvoiceTallyData.length > 0) {
                CCParti = data.CCMergeConInvoiceTallyData[0].particulars.split(
                  ","
                );
                CCCon = data.CCMergeConInvoiceTallyData[0].containerType.split(
                  ","
                );
                CCQuantity = data.CCMergeConInvoiceTallyData[0].quantity.split(
                  ","
                );
                CCSellingR = data.CCMergeConInvoiceTallyData[0].quotationRate.split(
                  ","
                );
                CCSF = data.CCMergeConInvoiceTallyData[0].sellingRateFinal.split(
                  ","
                );
                if (data.CCMergeConInvoiceTallyData[0].exchRate) {
                  EXRTCC = data.CCMergeConInvoiceTallyData[0].exchRate.split(
                    ","
                  );
                } else {
                  EXRTCC = [];
                }
                CCInvAmt = data.CCMergeConInvoiceTallyData[0].finalRateWithoutTax.split(
                  ","
                );
                CCCurrency = data.CCMergeConInvoiceTallyData[0].currency.split(
                  ","
                );
                UN = data.CCMergeConInvoiceTallyData[0].unit.split(",");

                CCRemark = data.CCMergeConInvoiceTallyData[0].remark.split(",");
              } else {
                //  this.alert.content = "Charges Not Received From CC";
                //         this.$refs["addPop"].open();
              }
              if (CCParti.length > 0) {
                CCParti.map((x, index) => {
                  let obj1 = {
                    ffType: x,
                    containerType: CCCon[index],
                    quantity: CCQuantity[index],
                    ffSellingRate: CCSellingR[index],
                    exchRate: EXRTCC[index],
                    sellingRateFinal: CCSF[index],
                    unit: UN[index],
                    invAmount: CCInvAmt[index],
                    currency: CCCurrency[index],

                    remark:
                      CCInvAmt[index] == "Charges As Per Receipt"
                        ? "Charges As Per Receipt " + " && " + CCRemark[index]
                        : CCRemark[index],
                    slectedStatus: "0",
                    color: "1"
                  };

                  this.ffTallyInvoiceData.push(obj1);
                });
              }
            }
            if (id == "1") {
              this.getData();
            }
          }
          this.isLoading = false;
        })
        .catch(error => {});
    },
    fetchDataContainerwise() {
      this.isLoading = true;
      let payload = {
        allModuleId: this.allModuleIdContainer,
        JOB: this.JOB
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/getDataContainerwiseTally.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.allContainersDataArray.length > 0) {
              this.allContainersDataArray = data.allContainersDataArray;
            }
            if (data.packageNameList.length > 0) {
              this.packageNameList = data.packageNameList;
            }
            if (data.LocationDetailsFinal.length > 0) {
              this.pickUpList = data.LocationDetailsFinal;
              this.handoverList = data.LocationDetailsFinal;
            }
            this.isLoading = false;
          }
        })
        .catch(error => {});
    },
    closeBill(id) {
      this.selectedAllModuleId = id;
      this.incompleteJobBill = "addPopClose";
      this.alert.content = "Are you sure to close Assignment Performa ?";
      this.$refs["addPopClose"].open();
    },
    closeBillOk(type) {
      if (type == "cancel") {
        this.incompleteJobBill = "";
      } else if (type == "ok") {
        this.incompleteJobBill = "InVoices Done";
      }
      if (this.incompleteJobBill == "InVoices Done") {
        this.closingReason = "Direct Close InVoices Done";
      }
      if (type != "cancel") {
        if (this.closingReason) {
          this.isLoading = true;
          let payload = {
            allModuleId: this.selectedAllModuleId,
            closingReason: this.closingReason
          };

          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_TallyBilling/closeBillingStatus.php`,
            data: JSON.stringify(payload),
            crossDomain: true,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId")
            }
          };
          axios(options)
            .then(result => {
              const { statusText, status, data } = result;
              if (status == 200 && data) {
                this.getData();
                this.isLoading = false;
              }
            })
            .catch(error => {});
        }
      }
    },
    changeOtherClient() {
      let arryDone = this.$store.getters["common/getAllClientList"].filter(
        x => {
          return x.clientId == this.ffInvoiceModal.clientId;
        }
      );
      if (arryDone.length > 0) {
        this.ffInvoiceModal.clientName = arryDone[0].clientName;
        this.ffInvoiceModal.contact = arryDone[0].phoneKYC;
        this.ffInvoiceModal.clientgst = arryDone[0].gstCode + arryDone[0].GSTN;
        this.ffInvoiceModal.stateName = arryDone[0].stateName;
        this.ffInvoiceModal.adress = arryDone[0].corporateAddress;
        this.ffInvoiceModal.fromAgentColoderTable =
          arryDone[0].fromAgentColoderTable;
      }
      if (this.mainExecutionDetails.length > 0) {
        if (
          this.mainExecutionDetails[0].clientId &&
          (this.mainExecutionDetails[0].clientId ==
            this.ffInvoiceModal.clientId ||
            this.mainExecutionDetails[0].exporterClientId ==
              this.ffInvoiceModal.clientId)
        )
          this.otherClientChecked = false;
      }
    },
    getAddedBillingBranchInv() {
      let payload = {
        profarmaLocationId: this.ffInvoiceModal.profarmaLocationId
      };

      let options = {
        method: "PUT",
        url: `${URL_BASE}/Api_TallyBilling/getExistingTallyData.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.existingBillingLocationData.length > 0) {
              this.ffInvoiceModal.tallyprofarmaSeries = parseInt(
                data.existingBillingLocationData.length
              );
            } else {
              this.ffInvoiceModal.tallyprofarmaSeries = 1;
            }
          }
        })
        .catch(error => {});
    },

    getBillingBranch() {
      let arryNewBillBranch = this.$store.getters[
        "common/getAllBillingLocationList"
      ].filter(x => {
        return x.billingLocationId == this.ffInvoiceModal.profarmaLocationId;
      });

      if (arryNewBillBranch.length > 0) {
        this.ffInvoiceModal.profarmaLocationId =
          arryNewBillBranch[0].billingLocationId;
        this.ffInvoiceModal.profarmaLocationName =
          arryNewBillBranch[0].billingLocation;
      }
      if (this.ffInvoiceModal.profarmaLocationId) {
        // this.getBranch(this.ffInvoiceModal.profarmaLocationId);
      }
      // alert(this.ffInvoiceModal.profarmaLocationName)
    },
    async getBranch(profarmaLocationId, fk_branch_id) {
      await this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
          billingLocationId: profarmaLocationId
        })
      );
      this.ffInvoiceModal.fk_branch_id = fk_branch_id;
      console.log(
        "Branch List=>",
        this.$store.dispatch(
          "common/getAllBranchList",
          JSON.stringify({
            filter: "BranchList",
            active: "all",
            billingLocationId: profarmaLocationId
          })
        )
      );
    },
    getOfficeBranch(profarmaLocationId, fk_branch_id) {
      this.$store.dispatch(
        "common/setAllBranchOfficeList",
        JSON.stringify({
          itemCode: "BranchOfficeList",
          active: "all",
          billingLocationId: profarmaLocationId,
          fk_branch_id: fk_branch_id
        })
      );
      this.ffInvoiceModal.fk_branch_id = fk_branch_id;
      // alert(this.ffInvoiceModal.fk_branch_id)
      this.BranchOfficeList = this.$store.getters[
        "common/getAllBranchOfficeList"
      ];
      if (this.BranchOfficeList.length > 0) {
        this.BranchOfficeList = data.BranchOfficeList;
        this.BranchOfficeList.forEach((BO_Val, BO_Key) => {
          if (BO_Key == 0) {
            this.ffInvoiceModal.fk_office_id = BO_Val.office_id;
          }
        });
      }
    },
    copyCharges() {
      if (this.selectedTallyInv == false) {
        this.showMoreItem();
      }
    },
    sendMail(type) {
      if (type != "cancel") {
        this.isLoading = true;

        let newData = {
          allModuleId: this.ffInvoiceModal.allModuleId,
          approvalMail: "approvalMail",
          executionNo: this.ffInvoiceModal.jobNo
        };
        if (this.validate != false) {
          let options = {
            method: "POST",
            url: `${URL_BASE}/Api_TallyBilling/sendApprovalRevisedBilling.php`,
            data: JSON.stringify(newData),
            crossDomain: true,
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: this.$sessionsStorage.get("loginId")
            }
          };

          axios(options)
            .then(result => {
              const { statusText, status, data } = result;
              $("#loaderS").css("display", "none");
              $("#addButtonLoaderS").css("display", "block");
              this.getData();
            })
            .catch(error => {});
        }
      }
    },
    openPop() {
      if (this.ffInvoiceModal.sentForRevisedApproval == "1") {
        this.confirm.contentHtml = "Already Sent  for Approval..?";
      } else {
        this.confirm.contentHtml = "Send   for Approval..?";
      }

      this.$refs["popMail"].open();
    },
    changeClient() {
      if (this.ffInvoiceModal.invoiceForClient == "1") {
        this.ffInvoiceModal.clientName = this.mainExecutionDetails[0].exporter;
        this.ffInvoiceModal.clientId = this.mainExecutionDetails[0].exporterClientId;
      } else {
        this.ffInvoiceModal.clientName = this.mainExecutionDetails[0].clientName;
        this.ffInvoiceModal.clientId = this.mainExecutionDetails[0].clientId;
      }
    },
    reload() {},
    showMoreItem() {
      Object.keys(this.ffInvoiceModal).map(x => {
        this.ffInvoiceModal[x] = "";
      });
      this.getData();

      this.newJobType = [];
      if (this.showMoreNewItem == false) {
        this.showMoreNewItem = true;
      } else {
        this.showMoreNewItem = false;
      }
    },
    goToMain() {
      this.ffInvoiceModal.profarma_id = "";
    },
    getDuplicateLedger(item, index) {},

    getAllTallyData() {
      this.ffTallyInvoiceData = [];

      this.isLoading = true;
      let vehicle_drive = {
        allModuleId: this.ffInvoiceModal.allModuleId,
        itemCode: "itemCode",
        jobType: this.newJobType,
        ccCheck: this.newJobType.indexOf("CC"),
        tptCheck: this.newJobType.indexOf("TPT"),
        ffCheck: this.newJobType.indexOf("FF"),
        miscCheck: this.newJobType.indexOf("MISC"),
        yardCheck: this.newJobType.indexOf("YARD"),
        ibCheck: this.newJobType.indexOf("IB"),
        CCCheckDone: this.CCCheckDone,
        ffCheckDone: this.ffCheckDone,
        TPTCheckDone: this.TPTCheckDone,
        miscCheckDone: this.miscCheckDone,
        yardCheckDone: this.yardCheckDone,
        ibCheckDone: this.ibCheckDone,
        splitFromId: this.mainExecutionDetails[0].splitFromId
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/fetchAllInvoiceTallyData.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            let CON_NO = [];
            let CONTYPE = [];
            // For CC
            if (
              this.newJobType.indexOf("CC") >= 0 ||
              this.newJobType.indexOf("MISC") >= 0 ||
              this.newJobType.indexOf("YARD") >= 0 ||
              this.newJobType.indexOf("IB") >= 0
            ) {
              let CCParti = [];
              let CCCon = [];
              let CCSellingR = [];
              let CCSF = [];
              let CCInvAmt = [];
              let CCCurrency = [];
              let CCQuantity = [];
              let CCRemark = [];
              let UN = [];
              let EXRTCC = [];

              if (data.ccInvoiceTallyData.length > 0) {
                this.ccInvoiceTallyData = data.ccInvoiceTallyData;
                this.ffInvoiceModal.POR = this.ccInvoiceTallyData[0].POR.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.POD = this.ccInvoiceTallyData[0].POD.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.LP = this.ccInvoiceTallyData[0].LP.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.FPOD = this.ccInvoiceTallyData[0].FPOD.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();

                CCParti = this.ccInvoiceTallyData[0].particulars.split(",");
                CCCon = this.ccInvoiceTallyData[0].containerType.split(",");
                CCQuantity = this.ccInvoiceTallyData[0].quantity.split(",");
                CCSellingR = this.ccInvoiceTallyData[0].quotationRate.split(
                  ","
                );
                CCSF = this.ccInvoiceTallyData[0].sellingRateFinal.split(",");
                if (this.ccInvoiceTallyData[0].exchRate) {
                  EXRTCC = this.ccInvoiceTallyData[0].exchRate.split(",");
                } else {
                  EXRTCC = [];
                }
                CCInvAmt = this.ccInvoiceTallyData[0].finalRateWithoutTax.split(
                  ","
                );
                CCCurrency = this.ccInvoiceTallyData[0].currency.split(",");
                UN = this.ccInvoiceTallyData[0].unit.split(",");

                CCRemark = this.ccInvoiceTallyData[0].remark.split(",");
                if (this.ccInvoiceTallyData[0].blNo) {
                  this.ffInvoiceModal.blNo = this.ccInvoiceTallyData[0].blNo;
                }
                if (this.ccInvoiceTallyData[0].vessel) {
                  this.ffInvoiceModal.vessel = this.ccInvoiceTallyData[0].vessel;
                }
                if (this.ccInvoiceTallyData[0].shippingLine) {
                  this.ffInvoiceModal.shippingLine = this.ccInvoiceTallyData[0].shippingLine;
                }
                if (this.ccInvoiceTallyData[0].weight) {
                  this.ffInvoiceModal.weight = this.ccInvoiceTallyData[0].weight;
                }
              } else if (data.miscInvoiceTallyData.length > 0) {
                this.miscInvoiceTallyData = data.miscInvoiceTallyData;
                this.ffInvoiceModal.POR = this.miscInvoiceTallyData[0].POR.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.POD = this.miscInvoiceTallyData[0].POD.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.LP = this.miscInvoiceTallyData[0].LP.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.FPOD = this.miscInvoiceTallyData[0].FPOD.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();

                CCParti = this.miscInvoiceTallyData[0].particulars.split(",");
                CCCon = this.miscInvoiceTallyData[0].containerType.split(",");
                CCQuantity = this.miscInvoiceTallyData[0].quantity.split(",");
                CCSellingR = this.miscInvoiceTallyData[0].quotationRate.split(
                  ","
                );
                CCSF = this.miscInvoiceTallyData[0].sellingRateFinal.split(",");
                if (this.miscInvoiceTallyData[0].exchRate) {
                  EXRTCC = this.miscInvoiceTallyData[0].exchRate.split(",");
                } else {
                  EXRTCC = [];
                }
                CCInvAmt = this.miscInvoiceTallyData[0].finalRateWithoutTax.split(
                  ","
                );
                CCCurrency = this.miscInvoiceTallyData[0].currency.split(",");
                UN = this.miscInvoiceTallyData[0].unit.split(",");

                CCRemark = this.miscInvoiceTallyData[0].remark.split(",");
                if (this.miscInvoiceTallyData[0].blNo) {
                  this.ffInvoiceModal.blNo = this.miscInvoiceTallyData[0].blNo;
                }
                if (this.miscInvoiceTallyData[0].vessel) {
                  this.ffInvoiceModal.vessel = this.miscInvoiceTallyData[0].vessel;
                }
                if (this.miscInvoiceTallyData[0].shippingLine) {
                  this.ffInvoiceModal.shippingLine = this.miscInvoiceTallyData[0].shippingLine;
                }
                if (this.miscInvoiceTallyData[0].weight) {
                  this.ffInvoiceModal.weight = this.miscInvoiceTallyData[0].weight;
                }
              } else {
                //  this.alert.content = "Charges Not Received From CC";
                //         this.$refs["addPop"].open();
              }
              if (CCParti.length > 0) {
                CCParti.map((x, index) => {
                  let obj1 = {
                    ffType: x,
                    containerType: CCCon[index],
                    quantity: CCQuantity[index],
                    ffSellingRate: CCSellingR[index],
                    exchRate: EXRTCC[index],
                    sellingRateFinal: CCSF[index],
                    unit: UN[index],
                    invAmount: CCInvAmt[index],
                    currency: CCCurrency[index],

                    remark:
                      CCInvAmt[index] == "Charges As Per Receipt"
                        ? "Charges As Per Receipt " + " && " + CCRemark[index]
                        : CCRemark[index],
                    slectedStatus: "0"
                  };

                  this.ffTallyInvoiceData.push(obj1);
                });
              }
            }

            // For FF
            if (this.newJobType.indexOf("FF") >= 0) {
              let TParti = [];
              let TCon = [];
              let TSelO = [];
              let TSF = [];
              let TINV = [];
              let TCUR = [];
              let TRE = [];
              let QUN = [];
              let FFINVID = [];
              let UNF = [];
              let EXRTFF = [];

              if (data.tallyTableData.length > 0) {
                this.tallyTableData = data.tallyTableData;

                this.ccInvoiceTallyData = data.ccInvoiceTallyData;

                if (this.tallyTableData[0].blNo) {
                  this.ffInvoiceModal.blNo = this.tallyTableData[0].blNo;
                }
                if (this.tallyTableData[0].vessel) {
                  this.ffInvoiceModal.vessel = this.tallyTableData[0].vessel;
                }
                if (this.tallyTableData[0].shippingLine) {
                  this.ffInvoiceModal.shippingLine = this.tallyTableData[0].shippingLine;
                }
                if (this.tallyTableData[0].weight) {
                  this.ffInvoiceModal.weight = this.tallyTableData[0].weight;
                }

                this.ffInvoiceModal.POR = this.tallyTableData[0].POR.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.POD = this.tallyTableData[0].POD.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.LP = this.tallyTableData[0].LP.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.FPOD = this.tallyTableData[0].FPOD.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();

                for (let r = 0; r < this.tallyTableData.length; r++) {
                  FFINVID = this.tallyTableData[r].InvTallyId;
                  TParti = this.tallyTableData[r].particulars.split(",");
                  TCon = this.tallyTableData[r].containerType.split(",");
                  QUN = this.tallyTableData[r].quantity.split(",");
                  TSelO = this.tallyTableData[r].quotationRate.split(",");
                  TSF = this.tallyTableData[r].sellingRateFinal.split(",");
                  TINV = this.tallyTableData[r].finalRateWithoutTax.split(",");
                  TCUR = this.tallyTableData[r].currency.split(",");
                  TRE = this.tallyTableData[r].remark.split(",");
                  UNF = this.tallyTableData[r].unit.split(",");
                  if (this.tallyTableData[0].exchRate) {
                    EXRTFF = this.tallyTableData[r].exchRate.split(",");
                  } else {
                    EXRTFF = [];
                  }

                  if (TParti.length > 0) {
                    TParti.map((y, index) => {
                      let obj = {
                        ffType: y,
                        containerType: TCon[index],
                        quantity: QUN[index],
                        ffSellingRate: TSelO[index],
                        exchRate: EXRTFF[index],

                        sellingRateFinal: TSF[index],
                        unit: UNF[index],
                        invAmount: TINV[index],
                        currency: TCUR[index],
                        remark:
                          TINV[index] == "Charges As Per Receipt"
                            ? "Charges As Per Receipt " + " && " + TRE[index]
                            : TRE[index],
                        mainffId: FFINVID,
                        slectedStatus: "0"
                      };
                      this.ffTallyInvoiceData.push(obj);
                    });
                  }
                }
              } else {
                //  this.alert.content = "Charges Not Received From FF";
                //         this.$refs["addPop"].open();
              }
            } else {
              this.ffCheckDone = 0;
            }

            // for TPT
            if (this.newJobType.indexOf("TPT") >= 0) {
              let TPTParti = [];
              let TPTCon = [];
              let TPTSelO = [];
              let TPTSF = [];
              let TPTINV = [];
              let TPTRE = [];
              let TPTQUN = [];
              let INVID = [];
              let UNT = [];

              if (data.TPTInvoiceTallyData.length > 0) {
                this.TPTInvoiceTallyData = data.TPTInvoiceTallyData;
                this.ffInvoiceModal.vessel = this.TPTInvoiceTallyData[0].vessel;
                this.ffInvoiceModal.pickup = this.TPTInvoiceTallyData[0].fromLocation
                  .replace(/\s*,\s*/g, ",")
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.Handover = this.TPTInvoiceTallyData[0].toLocation
                  .replace(/\s*,\s*/g, ",")
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.factoryLoc = this.TPTInvoiceTallyData[0].StuffingLocation.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                for (let p = 0; p < this.TPTInvoiceTallyData.length; p++) {
                  TPTParti = this.TPTInvoiceTallyData[p].particulars.split(",");
                  INVID = this.TPTInvoiceTallyData[p].invoiceId;
                  TPTCon = this.TPTInvoiceTallyData[p].containerType.split(",");
                  TPTQUN = this.TPTInvoiceTallyData[p].quantity.split(",");
                  UNT = this.TPTInvoiceTallyData[p].unit.split(",");
                  TPTSelO = this.TPTInvoiceTallyData[p].quotationRate.split(
                    ","
                  );
                  TPTSF = this.TPTInvoiceTallyData[p].sellingRateFinal.split(
                    ","
                  );
                  TPTINV = this.TPTInvoiceTallyData[
                    p
                  ].finalRateWithoutTax.split(",");
                  TPTRE = this.TPTInvoiceTallyData[p].remark.split(",");
                  if (TPTParti.length > 0) {
                    TPTParti.map((z, index) => {
                      let obj2 = {
                        ffType: z,
                        containerType: TPTCon[index],
                        quantity: TPTQUN[index],
                        ffSellingRate: TPTSelO[index],
                        exchRate: 1,
                        sellingRateFinal: TPTSF[index],
                        unit: UNT[index],
                        invAmount: TPTINV[index],
                        currency: "INR",

                        remark:
                          TPTINV[index] == "Charges As Per Receipt"
                            ? "Charges As Per Receipt " + " && " + TPTRE[index]
                            : TPTRE[index],
                        mainffId: INVID,
                        slectedStatus: "0"
                      };
                      this.ffTallyInvoiceData.push(obj2);
                    });
                  }
                }
              } else {
                //  this.alert.content = "Charges Not Received From TPT";
                //         this.$refs["addPop"].open();
              }
            } else {
              this.tptCheckDone = 0;
            }

            if (
              this.selectedTallyInv == false &&
              this.revisedSavedBillingData.length > 0
            ) {
              this.ffTallyInvoiceData = this.revisedSavedBillingData;
            }
            let BLno = this.ffInvoiceModal.blNo.replace(/ /g, "").split(",");
            console.log("BLno", BLno);
            BLno = [...new Set(BLno)];
            console.log("BLno", BLno);
            this.ffInvoiceModal.blNo = "";
            this.ffInvoiceModal.blNo = BLno.join(",");
            this.isLoading = false;
          }
          if (this.ffTallyInvoiceData.length > 0) {
            this.MainParticular();
          }
        })
        .catch(error => {});
    },
    jobTypeSelect(value, index) {
      
      this.singleSelectContainer = [];
      this.TPTGRNID = [];
      this.TPTGRNDATA = [];
      this.TPTMERGECONTAINERCHARGEID = [];
      this.selectedValue = value;
      this.ffInvoiceModal.jobTypeName = this.newJobType;
      let i = this.newJobType.indexOf(value);

      if (i >= 0) {
        this.newJobType.splice(i, 1);
      } else {
        this.newJobType.push(value);
      }
      let selectedJob = this.newJobType.toString();
      if (
        this.newJobType.includes("FF") &&
        this.newJobType.includes("CC") &&
        this.newJobType.includes("TPT")
      ) {
        let onlyFF = this.PerformaList.filter(x => {
          return x.jobType == "FF,CC,TPT" && x.addedToTallySucessStatus == "1";
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.secondFF = onlyFF.length;
        } else {
          this.ffInvoiceModal.secondFF = "";
        }
      } else if (
        this.newJobType.includes("FF") &&
        this.newJobType.includes("TPT")
      ) {
        let onlyFF = this.PerformaList.filter(x => {
          return x.jobType == "FF,TPT" && x.addedToTallySucessStatus == "1";
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.secondFF = onlyFF.length;
        } else {
          this.ffInvoiceModal.secondFF = "";
        }
      } else if (
        this.newJobType.includes("CC") &&
        this.newJobType.includes("TPT")
      ) {
        let onlyFF = this.PerformaList.filter(x => {
          return x.jobType == "CC,TPT" && x.addedToTallySucessStatus == "1";
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.secondFF = onlyFF.length;
        } else {
          this.ffInvoiceModal.secondFF = "";
        }
      } else if (
        this.newJobType.includes("FF") &&
        this.newJobType.includes("CC")
      ) {
        let onlyFF = this.PerformaList.filter(x => {
          return x.jobType == "FF,CC" && x.addedToTallySucessStatus == "1";
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.secondFF = onlyFF.length;
        } else {
          this.ffInvoiceModal.secondFF = "";
        }
      } else if (this.newJobType.includes("FF")) {
        let onlyFF = this.PerformaList.filter(x => {
          return x.jobType == "FF" && x.addedToTallySucessStatus == "1";
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.secondFF = onlyFF.length;
        } else {
          this.ffInvoiceModal.secondFF = "";
        }
      } else if (this.newJobType.includes("CC")) {
        let onlyFF = this.PerformaList.filter(x => {
          return x.jobType == "CC" && x.addedToTallySucessStatus == "1";
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.secondFF = onlyFF.length;
        } else {
          this.ffInvoiceModal.secondFF = "";
        }
      } else if (this.newJobType.includes("TPT")) {
        let onlyFF = this.PerformaList.filter(x => {
          return x.jobType == "TPT" && x.addedToTallySucessStatus == "1";
        });
        if (onlyFF.length > 0) {
          this.ffInvoiceModal.multiTPT = onlyFF.length;
        } else {
          this.ffInvoiceModal.multiTPT = "";
        }
      } else {
      }

      this.getAllTallyData();
    },
    getPreviousTallyData(pre_item) {
      console.log("pre_item=>", pre_item);
      this.ffInvoiceModal.fromAgentColoderTable =
        pre_item.fromAgentColoderTable;
      this.ffInvoiceModal.invoiceForClient = pre_item.invoiceForClient;
      this.ffInvoiceModal.otherChargeFF = pre_item.otherChargeFF;
      this.ffInvoiceModal.profarmaLocationId = pre_item.profarmaLocationId;
      this.ffInvoiceModal.profarmaLocationName = pre_item.profarmaLocationName;
      this.ffInvoiceModal.shipperInvNoforTally = pre_item.shipperInvNoforTally;
      this.ffInvoiceModal.shipperInvDateforTally =
        pre_item.shipperInvDateforTally;
      this.ffInvoiceModal.shipperInvNo = pre_item.shipperInvNo;
      this.ffInvoiceModal.shipperInvDate = pre_item.shipperInvDate;
      this.ffInvoiceModal.stateName = pre_item.stateName;
      this.ffInvoiceModal.clientgst = pre_item.clientgst;
      this.ffInvoiceModal.grnNo = pre_item.grnNo;
      this.ffInvoiceModal.pickup = pre_item.pickup;
      this.ffInvoiceModal.Handover = pre_item.Handover;
      this.ffInvoiceModal.factoryLoc = pre_item.factoryLoc;
      // this.ffInvoiceModal.jobType= pre_item.jobTypeNameArr;
      // this.ffInvoiceModal.jobTypeName= pre_item.jobTypeNameArr;
      this.ffInvoiceModal.jobNo = pre_item.jobNo;
      this.ffInvoiceModal.ffExportFclId = pre_item.ffExportFclId;
      this.ffInvoiceModal.allModuleId = pre_item.allModuleId;
      this.ffInvoiceModal.ccTypeExImp = pre_item.ccTypeExImp;
      this.ffInvoiceModal.weight = pre_item.weight;
      this.ffInvoiceModal.vessel = pre_item.vessel
        ? pre_item.vessel
        : this.ffInvoiceModal.vessel;
      this.ffInvoiceModal.blNo = pre_item.blNo;
      this.ffInvoiceModal.BOE = pre_item.BOE;
      this.ffInvoiceModal.clientId = pre_item.clientId;
      this.ffInvoiceModal.clientName = pre_item.clientName;
      this.ffInvoiceModal.contact = pre_item.contact;
      this.ffInvoiceModal.adress = pre_item.adress;
      this.ffInvoiceModal.POR = pre_item.POR;
      this.ffInvoiceModal.LP = pre_item.LP;
      this.ffInvoiceModal.POD = pre_item.POD;
      this.ffInvoiceModal.FPOD = pre_item.FPOD;
      this.ffInvoiceModal.shippingLine = pre_item.shippingLine;
      let BLno = this.ffInvoiceModal.blNo.replace(/ /g, "").split(",");
      console.log("BLno", BLno);
      BLno = [...new Set(BLno)];
      console.log("BLno", BLno);
      this.ffInvoiceModal.blNo = "";
      this.ffInvoiceModal.blNo = BLno.join(",");
      console.log("pre_item", pre_item);
      this.getBillData(pre_item)
    },
     getBillData(item) {
      this.showMoreNewItem = true;
      this.ffTallyInvoiceData = [];
      // Object.keys(this.ffInvoiceModal).map((x, index) => {
      //   if(x!=null && x!=undefined){
      //   this.ffInvoiceModal[x] = item[x];
      //   }
      // });

      let CCParti = [];
      let CCCon = [];
      let CCSellingR = [];
      let CCSF = [];
      let CCInvAmt = [];
      let exchRateArry = [];
      let CCCurrency = [];
      let CCQuantity = [];
      let CCRemark = [];
      let UN = [];

      if (item.particulars != null) {
        CCParti = item.particulars.split(",");
      }
      if (item.containerType != null) {
        CCCon = item.containerType.split(",");
      }
      if (item.quantity != null) {
        CCQuantity = item.quantity.split(",");
      }
      if (item.quotationRate != null) {
        CCSellingR = item.quotationRate.split(",");
      }
      if (item.sellingRateFinal != null) {
        CCSF = item.sellingRateFinal.split(",");
      }
      if (item.unit != null) {
        UN = item.unit.split(",");
      }
      if (item.finalRateWithoutTax != null) {
        CCInvAmt = item.finalRateWithoutTax.split(",");
      }
      if (item.exchRate) {
        exchRateArry = item.exchRate.split(",");
      }
      if (item.currency != null) {
        CCCurrency = item.currency.split(",");
      }
      if (item.remark != null) {
        CCRemark = item.remark.split(",");
      }

      if (CCParti.length > 0) {
        CCParti.map((x, index) => {
          let obj1 = {
            ffType: x,
            containerType: CCCon[index],
            quantity: CCQuantity[index],
            ffSellingRate: CCSellingR[index],
            exchRate: exchRateArry.length > 0 ? exchRateArry[index] : "1",
            sellingRateFinal: CCSF[index],
            unit: UN[index],
            invAmount: CCInvAmt[index],
            currency: CCCurrency[index],
            remark: CCRemark[index],
            slectedStatus: "0"
          };

          this.ffTallyInvoiceData.push(obj1);

          // this.CCCheckDone = 1;
        });

        // this.revisedSavedBillingData = this.ffTallyInvoiceData;
      }
    },
    getServicesData() {
      this.showSegmentArray = [];
      let jobArry = this.mainExecutionDetails[0].jobType.split(",");
      jobArry.map(x => {
        let obj = {
          value: x,
          show:
            x == "FF"
              ? "Freight Forwarding(" + x + ")"
              : x == "CC"
              ? "Custom Clearance(" + x + ")"
              : x == "TPT"
              ? "Transportation(" + x + ")"
              : x == "MISC"
              ? "MISC(" + x + ")"
              : x == "YARD"
              ? "YARD(" + x + ")"
              : x == "IB"
              ? "IB(" + x + ")"
              : "",
          flex: "20"
        };
        this.showSegmentArray.push(obj);
      });
    },
    getQuotRate() {
      let count1 = 0;
      this.ffTallyInvoiceData.map((x, index) => {
        if (x.quantity != "") {
          let finalAmt = parseInt(x.quantity) * parseInt(x.sellingRateFinal);
          x.invAmount = finalAmt;
        }
      });

      let count = 0;
      this.ffTallyInvoiceData.map((x, index) => {
        if (x.sellingRateFinal != "") {
          if (parseInt(x.sellingRateFinal) >= parseInt(x.ffSellingRate)) {
            count++;
          }
        }
      });
      if (count < this.ffTallyInvoiceData.length) {
        this.validateTally = true;
      } else {
        this.validateTally = false;
      }

      //   parseInt(item.sellingRateFinal) < parseInt(item.ffSellingRate)
      // );

      // if (item.sellingRateFinal < item.ffSellingRate) {
      //   this.validateTally = true;
      // } else {
      //   this.validateTally = false;
      // }
    },
    getFinalAmount(ind) {
      let count = 0;
      this.ffTallyInvoiceData[ind].invAmount =
        parseFloat(this.ffTallyInvoiceData[ind].quantity) *
        parseFloat(this.ffTallyInvoiceData[ind].sellingRateFinal) *
        parseFloat(this.ffTallyInvoiceData[ind].exchRate);
      if (
        parseInt(this.ffTallyInvoiceData[ind].sellingRateFinal) <
        parseInt(this.ffTallyInvoiceData[ind].ffSellingRate)
      ) {
        this.validateTally = true;
      } else {
        this.validateTally = false;
      }
    },
    cretaeProforma() {
      this.ffInvoiceModal.containerDetails = [];
      if (this.ffInvoiceModal.containerDetailsNew) {
        let selectedCon = this.ffInvoiceModal.containerDetailsNew.split(",");
        let selectedConType = this.ffInvoiceModal.multipleContainerType.split(
          ","
        );

        for (let w = 0; w < selectedCon.length; w++) {
          let objCon = {
            containerNoFF: selectedCon[w],
            containerTypeFF: selectedConType[w]
          };
          this.ffInvoiceModal.containerDetails.push(objCon);
        }
      }
      if (this.ffInvoiceModal.containerDetails.length <= 0) {
        this.alert.content = "Select At least 1 Container";
        this.$refs["addPop"].open();
        return false;
      }

      if (this.newJobType.length <= 0) {
        this.alert.content = "Select At least 1 JobType";
        this.$refs["addPop"].open();
        return false;
      }
      if (this.ffInvoiceModal.profarmaLocationId == "") {
        this.alert.content = "Please Select Performa Location";
        this.$refs["addPop"].open();
        return false;
      }

      this.alert.content =
        "Data will be added to " + this.ffInvoiceModal.profarmaLocationName;
      this.$refs["addPopTally"].open();
    },

    submitInvoice(type) {
      let id = "1";

      if (type != "cancel") {
        this.ffInvoiceModal.jobTypeName = this.newJobType;
        for (let t = 0; t < this.ffTallyInvoiceData.length; t++) {
          if (
            !this.ffTallyInvoiceData[t].slectedStatus ||
            this.ffTallyInvoiceData[t].slectedStatus == "0"
          ) {
            this.ffTallyInvoiceData.splice(t, 1);
          }
        }

        if (this.ffTallyInvoiceData.length > 0) {
          for (let r = 0; r < this.ffTallyInvoiceData.length; r++) {
            if (
              !this.ffTallyInvoiceData[r].slectedStatus ||
              this.ffTallyInvoiceData[r].slectedStatus == "0"
            ) {
              this.ffTallyInvoiceData.splice(r, 1);

              return false;
              break;
            } else {
              if (
                !this.ffTallyInvoiceData[r].ffType &&
                this.ffTallyInvoiceData[r].slectedStatus == "1"
              ) {
                this.alert.content =
                  "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
                this.$refs["addPop"].open();
                return false;
                break;
              } else if (
                !this.ffTallyInvoiceData[r].quantity &&
                this.ffTallyInvoiceData[r].slectedStatus == "1"
              ) {
                this.alert.content =
                  "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
                this.$refs["addPop"].open();
                return false;
                break;
              } 
              // else if (
              //   !this.ffTallyInvoiceData[r].ffSellingRate &&
              //   this.ffTallyInvoiceData[r].slectedStatus == "1"
              // ) {
              //   this.alert.content =
              //     "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
              //   this.$refs["addPop"].open();
              //   return false;
              //   break;
              // } 
              else if (
                !this.ffTallyInvoiceData[r].sellingRateFinal &&
                this.ffTallyInvoiceData[r].slectedStatus == "1"
              ) {
                this.alert.content =
                  "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
                this.$refs["addPop"].open();
                return false;
                break;
              } else if (
                !this.ffTallyInvoiceData[r].unit &&
                this.ffTallyInvoiceData[r].slectedStatus == "1"
              ) {
                this.alert.content =
                  "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
                this.$refs["addPop"].open();
                return false;
                break;
              } else if (
                !this.ffTallyInvoiceData[r].invAmount &&
                this.ffTallyInvoiceData[r].slectedStatus == "1"
              ) {
                this.alert.content =
                  "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
                this.$refs["addPop"].open();
                return false;
                break;
              } else if (
                !this.ffTallyInvoiceData[r].currency &&
                this.ffTallyInvoiceData[r].slectedStatus == "1"
              ) {
                this.alert.content =
                  "Please Enter All Paticulars,Quantity,Quotation Rate,Selling Rate,Unit,Final Amount,Currency in Charges Section";
                this.$refs["addPop"].open();
                return false;
                break;
              } else {
              }
            }
          }
        } else {
          this.alert.content = "Please Add minimum 1 Chagers to Tally";
          this.$refs["addPop"].open();
          return false;
          return false;
        }

        if (this.ffInvoiceModal.clientName == "") {
          this.alert.content = "Please Enter Client Name";
          this.$refs["addPop"].open();
          return false;
        }
        this.ffInvoiceModal["ffTallyInvoiceData"] = this.ffTallyInvoiceData;

        this.ffInvoiceModal["TPTGRNDATA"] = this.TPTGRNDATA;

        this.ffInvoiceModal["buttonId"] = id;
        let total = 0;

        this.ffTallyInvoiceData.map(x => {
          if (x.ffType == "TRANSPORT CHARGES") {
            this.ffInvoiceModal.TPTCHARGES = x.sellingRateFinal;
          }
          if (x.ffType == "TOLL CHARGES") {
            this.ffInvoiceModal.TOLCHRG = x.sellingRateFinal;
          }
          let dummy = parseFloat(x.invAmount) + total;
          total = dummy;
        });

        this.ffInvoiceModal.totalAmount = total;
        this.ffInvoiceModal["manualprofarma"] = "0";
        if (this.otherClientChecked == true) {
          this.ffInvoiceModal["otherClientChecked"] = "Y";
        }
        this.ffInvoiceModal[
          "singleSelectContainer"
        ] = this.singleSelectContainer;

        if (this.validateInvoice != false) {
          let payload = {
            itemCode: "Create_Proforma",
            ffInvoiceModal: this.ffInvoiceModal
          };
          // payload = JSON.stringify(payload);
          console.log("Priyanshu SIngh Parforma =>", payload);
          CommonService.getAllProformaInvoice(payload)
            .then(response => {
              const { data, status, statusText } = response;
              if (status == 200 && data) {
                if (data.profarma_id != "" && data.profarma_id != undefined) {
                  if (data.find == 1 || data.find == 2) {
                    this.alert.content = data.MSG;
                  } else {
                    this.alert.content = data.MSG;
                  }
                } else {
                  this.alert.content = data.MSG;
                }
                this.$refs["addPop"].open();
                this.getData(id);
                this.slectedAllStatus = "0";
              }
              this.isLoading = false;
            })
            .catch(error => {
              console.log("Catch on  Add Permorma Details Error: ", error);
            });
        }
      }
    },

    removeCol(index) {
      this.ffTallyInvoiceData.splice(index, 1);
    },
    SelectedAll() {
      for (let r = 0; r < this.ffTallyInvoiceData.length; r++) {
        if (this.slectedAllStatus == "1") {
          this.ffTallyInvoiceData[r].slectedStatus = "1";
        } else {
          this.ffTallyInvoiceData[r].slectedStatus = "0";
        }
      }
    },

    removeGRN(index, item) {
      let i = 0;
      while (i < this.ffTallyInvoiceData.length) {
        let x = item.invoiceId;
        if (this.ffTallyInvoiceData[i].mainffId == x) {
          this.ffTallyInvoiceData.splice(i, 1);
        } else {
          ++i;
        }
      }

      this.TPTGRNDATA.splice(index, 1);
    },

    removeFFContainer(index, itemAll) {
      let p = 0;
      while (p < this.ffTallyInvoiceData.length) {
        let y = itemAll.FFInvIdId;
        if (this.ffTallyInvoiceData[p].mainffId == y) {
          this.ffTallyInvoiceData.splice(p, 1);
        } else {
          ++p;
        }
      }
      this.ffInvoiceModal.containerDetails.splice(index, 1);
    },

    addQuotationFields() {
      let tableFields = {
        slectedStatus: "1",
        ffType: "",
        containerType: "",
        quantity: "",
        ffSellingRate: "",
        exchRate: "1",
        sellingRateFinal: "",
        invAmount: "",
        currency: "",
        remark: "",
        mainffId: ""
      };

      this.ffTallyInvoiceData.push(tableFields);
    },
    async getData(id) {
      this.ffTallyInvoiceData = [];
      this.isLoading = true;
      let payload = {
        itemCode: "allProforma",
        allModuleId: this.$route.params.allModuleId,
        InvTallyId: this.$route.query.InvTallyId
      };
      payload = JSON.stringify(payload);

      Promise.all(
        CommonService.getAllProformaInvoice(payload)
          .then(response => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              console.log("Priyanshu Singh=>", data);
              if (data.mainExecutionDetails.length > 0) {
                this.getBranch(
                  data.mainExecutionDetails[0].profarmaLocationId,
                  data.mainExecutionDetails[0].addedBy_user_baseLocation
                );
              }
              if (data.fflastData.length > 0) {
                this.tempffTableArry = data.fflastData;
              }

              if (data.PerformaList.length > 0) {
                this.PreviousPerformaList = data.PerformaList;
              }

              if (data.enquiryData.length > 0) {
                this.enquiryData.shipmentType =
                  data.enquiryData[0].shipmentType;
                this.enquiryData.fclOrlcl = data.enquiryData[0].containerInfo;
              }

              if (data.ccTableData.length > 0) {
                this.ccTableArry = data.ccTableData;
              }

              if (data.tptTableData.length > 0) {
                this.tptTableData = data.tptTableData;
              }

              if (data.allContainers.length > 0) {
                this.allContainersDataArray = data.allContainers;
              }

              if (data.tptMain.length > 0) {
                Object.keys(data.tptMain[0]).map(x => {
                  this.tptModal[x] = data.tptMain[0][x] || "";
                });
              } else {
                this.tptModal.distance = data.distancegps;
              }
              // alert(data.mainExecutionDetails.length);
              if (data.mainExecutionDetails.length > 0) {
                this.mainExecutionDetails = data.mainExecutionDetails;
                this.shipmentType = data.mainExecutionDetails[0].shipmentType;
                if (this.$route.query.classId) {
                  this.classId = this.$route.query.classId;
                  this.ffInvoiceModal.jobNo =
                    data.mainExecutionDetails[0].mainSalesSeries +
                    "/" +
                    this.classId;
                } else {
                  this.ffInvoiceModal.jobNo =
                    data.mainExecutionDetails[0].mainSalesSeries;
                }
                // Priyanshu Singh Start

                this.ffInvoiceModal.shippingLine =
                  data.mainExecutionDetails[0].shippingLine;
                this.ffInvoiceModal.shipperInvNo =
                  data.mainExecutionDetails[0].shipperInvoiceNo;
                this.ffInvoiceModal.BOE =
                  data.mainExecutionDetails[0].shippingBillNo;
                this.ffInvoiceModal.LP = data.mainExecutionDetails[0].Load_port.replace(
                  /\s*,\s*/g,
                  ","
                )
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.POD = data.mainExecutionDetails[0].port_of_discharge
                  .replace(/\s*,\s*/g, ",")
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.POR = data.mainExecutionDetails[0].place_of_receipt
                  .replace(/\s*,\s*/g, ",")
                  .replace(/\s\s+/g, " ")
                  .trim();
                this.ffInvoiceModal.FPOD = data.mainExecutionDetails[0].fpod
                  .replace(/\s*,\s*/g, ",")
                  .replace(/\s\s+/g, " ")
                  .trim();

                if (data.ffmaindetails.length > 0) {
                  this.ffInvoiceModal.vessel = data.ffmaindetails[0].vessel;
                  this.ffInvoiceModal.blNo = data.ffmaindetails[0].blNo;
                  this.ffInvoiceModal.weight = data.ffmaindetails[0].weight;
                } else if (data.ccmaindetails.length > 0) {
                  this.ffInvoiceModal.vessel = data.ccmaindetails[0].vessel;
                  this.ffInvoiceModal.blNo = data.ccmaindetails[0].blNo;
                  this.ffInvoiceModal.weight = data.ccmaindetails[0].weight;
                } else {
                  this.ffInvoiceModal.vessel = "";
                  this.ffInvoiceModal.blNo = "";
                  this.ffInvoiceModal.weight = "";
                }

                this.ffInvoiceModal.Handover =
                  data.mainExecutionDetails[0].handoverloc;
                this.ffInvoiceModal.pickup =
                  data.mainExecutionDetails[0].pickuploc;
                this.ffInvoiceModal.factoryLoc =
                  data.mainExecutionDetails[0].factoryloc;
                // Priyanshu Singh End
                this.ffInvoiceModal.sentForRevisedApproval =
                  data.mainExecutionDetails[0].sentForRevisedApproval;
                this.ffInvoiceModal.revisedActionTakenFromMail =
                  data.mainExecutionDetails[0].revisedActionTakenFromMail;

                if (this.mainExecutionDetails[0].clientType != "3") {
                  this.ffInvoiceModal.clientName =
                    data.mainExecutionDetails[0].clientName;
                  this.ffInvoiceModal.clientId =
                    data.mainExecutionDetails[0].clientId;
                  this.ffInvoiceModal.acutalclientForOverSea =
                    data.mainExecutionDetails[0].exporter;
                  this.ffInvoiceModal.stateName =
                    data.mainExecutionDetails[0].stateName;
                  this.ffInvoiceModal.clientgst =
                    data.mainExecutionDetails[0].gstCode +
                    data.mainExecutionDetails[0].GSTN;
                  this.ffInvoiceModal.contact =
                    data.mainExecutionDetails[0].kycContact;
                  this.ffInvoiceModal.adress =
                    data.mainExecutionDetails[0].corporateAddress;
                }

                this.ffInvoiceModal.allModuleId =
                  data.mainExecutionDetails[0].allModuleId;

                this.ffInvoiceModal.ccTypeExImp =
                  data.mainExecutionDetails[0].transportType;
                this.ffInvoiceModal.shippingLine =
                  data.mainExecutionDetails[0].shippingLine;
                this.ffInvoiceModal.profarmaLocationId =
                  data.mainExecutionDetails[0].profarmaLocationId;
                this.getServicesData();
              }

              if (data.InvoiceData.length > 0) {
                this.ffInvoiceModal.clientName = data.InvoiceData[0].clientName;
                this.ffInvoiceModal.address = data.InvoiceData[0].address;
                this.ffInvoiceModal.contact = data.InvoiceData[0].contact;
              }
              if (data.PerformaList.length > 0) {
                this.PerformaList = data.PerformaList;
                this.disableJobType = data.PerformaList[0].jobType;
              } else {
                this.PerformaList = [];
              }
              if (id == "1") {
                this.showMoreItem();
                Object.keys(this.ffInvoiceModal).map(x => {
                  this.ffInvoiceModal[x] = "";
                });
              }
              if (
                this.selectedTallyInv == false &&
                this.revisedSavedBillingData.length > 0
              ) {
                this.ffTallyInvoiceData = this.revisedSavedBillingData;
              }

              if (data.mainExecutionDetails.length > 0) {
                let arryNewBillBranch = this.$store.getters[
                  "common/getAllBillingLocationList"
                ].filter(x => {
                  if (x.branchLocation) {
                    return x.branchLocation
                      .split(",")
                      .includes(
                        data.mainExecutionDetails[0].addedBy_user_baseLocation
                      );
                  }
                });

                if (arryNewBillBranch.length > 0) {
                  this.ffInvoiceModal.profarmaLocationId =
                    arryNewBillBranch[0].billingLocationId;
                  this.ffInvoiceModal.profarmaLocationName =
                    arryNewBillBranch[0].billingLocation;
                }
              }
            }

            // alert(this.ffInvoiceModal.profarmaLocationId)
            if (this.ffInvoiceModal.profarmaLocationId) {
              // Promise.all(

              if (data.mainExecutionDetails.length > 0) {
                this.ffInvoiceModal.fk_branch_id =
                  data.mainExecutionDetails[0].addedBy_user_baseLocation;
              }

              // alert(this.$store.getters["common/getAllBranchList"].length);

              if (
                this.ffInvoiceModal.fk_branch_id &&
                this.$store.getters["common/getAllBranchList"].length > 0
              ) {
                this.getOfficeBranch(
                  this.ffInvoiceModal.profarmaLocationId,
                  this.ffInvoiceModal.fk_branch_id
                );
              }

              if (data.BranchOfficeList.length > 0) {
                this.BranchOfficeList = data.BranchOfficeList;
                this.BranchOfficeList.forEach((BO_Val, BO_Key) => {
                  if (BO_Key == 0) {
                    this.ffInvoiceModal.fk_office_id = BO_Val.office_id;
                  }
                });
              }
              let BLno = this.ffInvoiceModal.blNo.replace(/ /g, "").split(",");
              console.log("BLno", BLno);
              BLno = [...new Set(BLno)];
              console.log("BLno", BLno);
              this.ffInvoiceModal.blNo = "";
              this.ffInvoiceModal.blNo = BLno.join(",");
              // alert(data.BranchOfficeList.length);

              // this.getOfficeBranch();
            }
            this.isLoading = false;
          })
          .catch(error => {
            console.log("Catch on Overseas_Agent_SOA Error: ", error);
          })
      );
    },
    PrintNote(assignmentNo, uploadCreditDebit) {
      this.openSignedDocument(`ASSIGNMENT_UPLOADS/${assignmentNo.replaceAll("/", "_")}/${uploadCreditDebit}`);
    },

    // Added By Priyanshu Singh Start
    validateBilling(id, jobType) {
      this.selectedAllModuleId = id;
      this.isLoading = true;
      let payload = {
        allModuleId: id,
        job: jobType
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/validateCloseBilling.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.incompleteJobBill.length > 0) {
              this.incompleteJobBill = data.incompleteJobBill.toString();
              this.$refs["modal-close-conf"].show();
            } else {
              // alert("Hello");
              this.closeBill(id);
            }

            this.isLoading = false;
          }
        })
        .catch(error => {});
    },
    closeModalConfirm() {
      (this.incompleteJobBill = ""), this.$refs["modal-close-conf"].hide();
    },
    MainParticular() {
      this.TotalParticularFinalAmount();
    },
    TotalParticularFinalAmount() {
      let TotAmount = 0;
      this.ffTallyInvoiceData.forEach((value, index) => {
        let amount = 0;
        if (isNaN(value.invAmount) || value.invAmount == "") {
          amount = 0;
        } else {
          amount = value.invAmount;
        }
        if (this.totFinalPartAmount == 0) {
          TotAmount = eval(amount);
        } else {
          TotAmount = eval(TotAmount) + eval(amount);
        }
        this.totFinalPartAmount = TotAmount;
      });
      this.$forceUpdate();
    },
    SelectAll: function() {
      this.isCheckAll = !this.isCheckAll;
      this.singleSelectContainer = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.allContainersDataArray) {
          let single_data = "";
          this.singleSelectContainer.push(
            this.allContainersDataArray[key].uniqueContainerId
          );
        }
      }
    },
    updateSelectAll: function(e, item) {
      if (
        this.singleSelectContainer.length == this.allContainersDataArray.length
      ) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
      const istrue = this.singleSelectContainer.includes(
        item.uniqueContainerId
      );
    },
    // Added By Priyanshu Singh End
    previousSalesView() {
      window.history.go(-1);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// assignmentPerforma.vue?6a6759e0